import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter, OnDestroy,
  Output, ViewChild,
} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {GlobalSearchResult} from "./global-search-result";
import {ImageService} from "../../atoms/image/image.service";
import _ from "lodash";
import {DataService} from "../../services/data.service";
import {take} from "rxjs";

@Component({
  selector: 'brt-global-search-overlay',
  templateUrl: './global-search-overlay.component.html',
  styleUrls: ['./global-search-overlay.component.scss']
})
export class GlobalSearchOverlayComponent implements Overlayable, AfterViewInit, OnDestroy {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @ViewChild('inputElement') inputElement!: ElementRef<null>;
  @ViewChild('dialogElement') dialogElement!: any;

  searchTerm: string = "";
  isLoading = true;

  debouncedSearchValueUpdateTrigger = _.debounce(() => this.onSearchValueChanged(), 500)
  constructor(private image: ImageService, private data: DataService) {
  }
  results: GlobalSearchResult[] = [
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
    // {
    //   image: this.image.getPlaceholderImage(),
    //   quote: "... A condimentum ridiculus <em>kochen</em> a est ultrices volutpat amet. Vitae augu...",
    //   title: "Lehrlingsportrait <emKöch</em>in / <em>Koch</em>",
    //   type: "Einblicke"
    // },
  ];

  ngAfterViewInit() {
    if(this.dialogElement && this.dialogElement.nativeElement) {
      const el = this.dialogElement.nativeElement as HTMLDialogElement;
      el.showModal();
    }
    if(this.inputElement && this.inputElement.nativeElement) {
      const inputEl = this.inputElement.nativeElement as HTMLInputElement;
      // @ts-ignore
      inputEl.focus({focusVisible: false, preventScroll: true});
    }
  }

  onSearchValueChanged(): void {
    this.isLoading = true
    if(this.searchTerm.length) {
      this.data.getGlobalSearchResults(this.searchTerm).pipe(take(1)).subscribe((results) => {
        this.results = results;
        this.isLoading = false;
      });
    }

  }

  clearField() {
    if (this.searchTerm.length) {
      this.searchTerm = "";
      this.onSearchValueChanged();
    } else {
      this.onClosed.emit(true);
    }

  }

  // onKeyUp($event: KeyboardEvent) {
  //   if($event.key === "Enter") {
  //     if(this.inputElement.nativeElement) {
  //       const inputEl = this.inputElement.nativeElement as HTMLInputElement;
  //       inputEl.blur();
  //     }
  //   }
  // }

  ngOnDestroy() {
    if(this.dialogElement) {
      const el = this.dialogElement.nativeElement as HTMLDialogElement;
      el.close();

      const backToElement = window.document.querySelector(".header__meta-item.header__meta-item--icon.search button") as HTMLElement;

      console.log(backToElement);
      if(backToElement) {

        backToElement.focus();
      }
    }
  }
}
